var menu = document.getElementById('menu'),
	mobileMenuButton = document.getElementById('mobile-menu-button'),
	siteSwitcherButton = document.getElementById('site-switcher-button');

body.addEventListener('click', function(e) {
	checkAndCloseMenu(e.target);
});

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		checkAndCloseMenu(menu);
});

function checkAndCloseMenu(e) {
	var open = openMenu(e);

	if(open && checkWidth(1200)) {
		closeMenu(open);
		toggleMenuBodyClass(false);
	}
}

[].slice.call(navwrap.querySelectorAll('button:not([type="submit"]):not(.lang-button)')).forEach(function(navLink) {
	navLink.addEventListener('click', toggleMenu);
});

function toggleMenu() {
	closeMenu(openMenu(this));

	var parent = this.parentNode.parentNode,
		openSibling = parent.querySelector('.open');

	if(parent.classList.contains('submenu') && openSibling && openSibling != this)
		closeMenu(openSibling);

	var isOpen = this.classList.contains('open'),
		animation = checkWidth(1200) && menu.contains(this) ? (isOpen ? 'slideUp' : 'slideDown') : (isOpen ? 'fadeOut' : 'fadeIn')
		display = isOpen ? 'none' : (this == siteSwitcherButton ? 'block' : 'flex'),
		submenu = this.nextElementSibling;

	Velocity(submenu, animation, {duration: 300, display});

	this.classList.toggle('open');

	submenu.setAttribute('aria-expanded', (submenu.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

	toggleMenuBodyClass(navwrap.querySelector('.open'));
}

function closeMenu(el) {
	if(el) {
		el.classList.remove('open');

		var submenu = el.nextElementSibling;

		if(submenu) {
			Velocity(submenu, checkWidth(1200) && menu.contains(el) ? 'slideUp' : 'fadeOut', {duration: 300});
			submenu.setAttribute('aria-expanded', 'false');
			closeMenu(submenu.querySelector('.open'));
		}
	}
}

function openMenu(el) {
	if(mobileMenuButton && mobileMenuButton.classList.contains('open') && mobileMenuButton != el && !mobileMenuButton.contains(el) && !document.getElementById('menu-container').contains(el))
		return mobileMenuButton;

	var openButton = navwrap.querySelector('button:not(#mobile-menu-button).open');

	return openButton && !openButton.parentNode.contains(el) ? openButton : false;
}

function toggleMenuBodyClass(open) {
	if(open)
		body.classList.add('menu-open');
	else
		body.classList.remove('menu-open');

	setFocus((open ? true : false), header);
}